import * as React from 'react';
import {
    Button,
    ButtonGroup,
    ButtonToolbar,
    Col,
    ControlLabel,
    Form,
    FormControl,
    Modal,
    OverlayTrigger,
    Panel,
    Row,
    Tooltip
} from 'react-bootstrap';
import { connect } from 'react-redux';
import notify from '../../../../../shared/feedback/notifications';
import { Translate } from '../../../../../shared/LanguageService';
import * as actions from '../actions/ImageProcessingActions';
import { handleError } from '../../../../../shared/ErrorCatching';
import { IComment, IImage, ImageType } from '../Entities';
import { assign } from '../../../../../shared/Assign';
import FormInputChangeHandler from '../../../../../shared/form/FormInputChangeHandler';
import * as Features from '../../../../../shared/Features';
import ConfirmationModal from '../../../../../components/common/ConfirmationModal';
import * as PhotoStatus from '../../../../../shared/PhotoStatus';
import ImageProcessingDropzone from './ImageProcessingDropzone';
import ImageProcessingCategorySection from './ImageProcessingCategorySection';
import ImageProcessingCommentsSection from './ImageProcessingCommentsSection';
import PreloadImageContainer from './PreloadImageContainer';
import { default as ImageZoom } from './ImageZoom';
import { selectEditedImages, selectUneditedImages } from '../reducer/ImageProcessingReducer';
import { UserRole } from '../../../../../shared/types';
import ImageProcessingRoomTagging from '../roomTagging/view/ImageProcessingRoomTagging';
import SwipeListener from '../../../../../shared/SwipeListener';
import normalIcon from '../../../../../assets/images/normal_scale_24px.svg';
import moment from 'moment';

enum Direction {
    Left = -1,
    Right = 1
}

class ImageProcessingModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            comment: {
                text: '',
                toImageEditor: false,
                toPhotographer: false,
                toCustomer: false,
                toSe360: false,
                errors: {}
            },
            filter: {
                photographer: true,
                imageEditor: true,
                customer: true,
                se360: true
            },
            shownImage: {
                index: 0,
                filename: '',
                reference: '',
                id: 0,
                comments: [],
                width: 0,
                height: 0,
                fileSize: 0,
                dpi: 0,
                category: 0,
                parentId: null,
                canDelete: false,
                hasDeliveryConnection: false,
                isFavorited: false
            },
            needsEditing: false,
            images: [],
            role: 0,
            enableCategoryDropdown: false,
            selectedCategory: 0,
            editFilename: false,
            commentsOpen: false,
            editedFilename: '',
            imageId: 0,
            showNeedsEditingModal: false,
            nextImage: null,
            previousImage: null,
            isImageLoaded: false
        };

        this.showImage = this.showImage.bind(this);
        this.getImage = this.getImage.bind(this);
        this.setCommentSectionState = this.setCommentSectionState.bind(this);
        this.saveComment = this.saveComment.bind(this);
        this.setNeedsEditingState = this.setNeedsEditingState.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.stepInGallery = this.stepInGallery.bind(this);
        this.getCategories = this.getCategories.bind(this);
        this.onCategorySave = this.onCategorySave.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.onCategoryCancelClick = this.onCategoryCancelClick.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.downloadImage = this.downloadImage.bind(this);
        this.setEditFilenameInputState = this.setEditFilenameInputState.bind(this);
        this.toggleComments = this.toggleComments.bind(this);
        this.onFilenameChange = this.onFilenameChange.bind(this);
        this.saveNewFilename = this.saveNewFilename.bind(this);
        this.getLatestChildImage = this.getLatestChildImage.bind(this);
        this.shouldShowCommentsSection = this.shouldShowCommentsSection.bind(this);
        this.deleteEditedPhoto = this.deleteEditedPhoto.bind(this);
        this.toggleShowDeleteConfirmationModal = this.toggleShowDeleteConfirmationModal.bind(this);
        this.showNeedsEditingModal = this.showNeedsEditingModal.bind(this);
        this.getStatusIcon = this.getStatusIcon.bind(this);

        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state,
            this.setCommentSectionState
        );
    }

    UNSAFE_componentWillMount() {
        let imageId = this.props.imageId;
        if (imageId) {
            this.getImage(imageId);
            this.getCategories();
            this.setState({ imageId: imageId });
        }

        this.registerKeyEvent();
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.images && nextProps.images.length > 0) {
            let index = nextProps.images.length - 1;
            let image = nextProps.images[index];
            if (image) {
                this.setState({
                    shownImage: {
                        index: index,
                        reference: image.reference,
                        highResImageReference: image.highResImageReference,
                        id: image.id,
                        comments: image.commentModel ? image.commentModel.comments : null,
                        filename: image.filename,
                        width: image.width,
                        height: image.height,
                        fileSize: image.fileSize,
                        dpi: image.dpi,
                        category: image.category,
                        normalImageReference: image.normalImageReference,
                        parentId: image.parentId,
                        canDelete: image.canDelete,
                        hasDeliveryConnection: image.hasDeliveryConnection,
                        isCustomerApproved: image.isCustomerApproved,
                        isFavorited: image.isFavorited
                    },
                    role: image.commentModel ? image.commentModel.role : -1,
                    needsEditing: image.needsEditing,
                    images: assign([], nextProps.images),
                    editedFilename: '',
                    editFilename: false,
                    selectedCategory: image.category
                });

                this.formInputChangeHandler.updateObj(this.state);
            }
        }
    }

    componentWillUnmount() {
        this.unregisterKeyEvent();
    }

    setCommentSectionState(state: any) {
        this.setState({ comment: state.comment, filter: state.filter });
    }

    showNeedsEditingModal() {
        if (this.state.needsEditing === true) {
            this.setNeedsEditingState();
        } else {
            this.setState({ showNeedsEditingModal: true });
        }
    }

    setNeedsEditingState(e?: any) {
        this.setState((prevState) => ({
            needsEditing: !prevState.needsEditing
        }));
        this.props.actions
            .saveNeedsEditing(
                this.props.orderId,
                this.state.shownImage.id,
                !this.state.needsEditing
            )
            .then(() => {
                if (
                    this.enableSaveComment() &&
                    this.state.comment.text &&
                    this.state.needsEditing
                ) {
                    this.saveComment();
                }
                this.props.actions.getPhotoStatus(this.props.orderId);
                this.setState({ showNeedsEditingModal: false });

                if (this.state.needsEditing) {
                    notify.success(Translate('image-processing/modal/notification/return-success'));
                }
            })
            .catch((error: any) => handleError(error));
    }

    getLatestChildImage(id: number) {
        this.props.actions
            .getLatestImage(this.props.orderId, id)
            .catch((error: any) => handleError(error));
    }

    getImage(imageId: number) {
        this.props.actions
            .getImage(this.props.orderId, imageId)
            .catch((error: any) => handleError(error));
    }

    getCategories() {
        this.props.actions
            .getCategories(this.props.orderId)
            .catch((error: any) => handleError(error));
    }

    onCategorySave(category) {
        this.props.actions.updateCategory(
            this.props.orderId,
            this.state.shownImage.id,
            parseInt(category)
        );
        this.setState({ enableCategoryDropdown: false });
    }

    onCategoryClick() {
        this.setState({ enableCategoryDropdown: true });
    }

    onCategoryChange(e: any) {
        this.setState({ selectedCategory: parseInt(e.target.value) });
    }

    onCategoryCancelClick() {
        this.setState({
            selectedCategory: this.state.shownImage.category.id,
            enableCategoryDropdown: false
        });
    }

    saveComment() {
        let comment: IComment = this.state.comment;
        let toPhotographer = comment.toPhotographer ? 1 : 0;
        let toImageEditor = comment.toImageEditor ? 2 : 0;
        let toSe360 = comment.toSe360 ? 8 : 0;
        let recipients = toPhotographer + toImageEditor + toSe360;

        this.props.actions
            .saveComment(this.props.orderId, this.state.shownImage.id, comment.text, recipients)
            .then(() => {
                let comment = {
                    text: '',
                    toImageEditor: false,
                    toPhotographer: false,
                    toCustomer: false,
                    toSE360: false,
                    errors: {}
                };
                this.setState({ comment: comment });
                this.formInputChangeHandler.updateObj(this.state);
            })
            .catch((error: any) =>
                handleError(error, (errors: any) => {
                    let comment = this.state.comment;
                    comment.errors = errors;
                    this.setState({ comment: comment });
                    this.formInputChangeHandler.updateObj(this.state);
                })
            );
    }

    enableSaveComment() {
        return (
            this.state.comment.toSe360 ||
            this.state.comment.toImageEditor ||
            this.state.comment.toPhotographer
        );
    }

    toggleComments() {
        let isOpen = this.state.commentsOpen;
        this.setState({ commentsOpen: !isOpen });
    }

    showImage(image: IImage, index: number) {
        this.setState({
            shownImage: {
                index: index,
                reference: image.reference,
                highResImageReference: image.highResImageReference,
                id: image.id,
                comments: image.commentModel.comments,
                filename: image.filename,
                needsEditing: image.needsEditing,
                width: image.width,
                height: image.height,
                fileSize: image.fileSize,
                dpi: image.dpi,
                category: image.category,
                normalImageReference: image.normalImageReference,
                parentId: image.parentId,
                canDelete: this.state.images.length - 1 === index ? image.canDelete : false,
                hasDeliveryConnection: image.hasDeliveryConnection,
                isCustomerApproved: image.isCustomerApproved,
                isFavorited: image.isFavorited
            }
        });

        this.formInputChangeHandler.updateObj(this.state);
    }

    registerKeyEvent() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    unregisterKeyEvent() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e: KeyboardEvent) {
        const { activeElement } = document;
        const isInputActive =
            activeElement instanceof HTMLInputElement ||
            activeElement instanceof HTMLTextAreaElement;

        const { editFilename, enableCategoryDropdown } = this.state;

        if (isInputActive || editFilename || enableCategoryDropdown) return;

        switch (e.key) {
            case 'ArrowLeft':
                this.stepInGallery(Direction.Left);
                break;
            case 'ArrowRight':
                this.stepInGallery(Direction.Right);
                break;
            default:
                break;
        }
    }

    stepInGallery(direction: Direction) {
        const { idList } = this.props;
        const { imageId: currentImageId } = this.state;

        const currentIndex = idList.indexOf(currentImageId);
        let newIndex = currentIndex;

        if (direction === Direction.Left) {
            newIndex = Math.max(0, currentIndex - 1);
        } else if (direction === Direction.Right) {
            newIndex = Math.min(idList.length - 1, currentIndex + 1);
        }

        const newImageId = idList[newIndex];

        if (newImageId === currentImageId) return;

        this.setState({
            imageId: newImageId,
            selectedCategory: 0,
            isImageLoaded: false
        });

        this.getImage(newImageId);
    }

    downloadImage() {
        if (this.state.shownImage.filename.toLowerCase().endsWith('.dng')) {
            actions
                .downloadDNGImage(this.props.orderId, this.state.shownImage.id)
                .catch((error) => handleError(error));
        } else {
            actions
                .downloadImage(this.props.orderId, this.state.shownImage.id)
                .catch((error) => handleError(error));
        }
    }

    setEditFilenameInputState(editFilename: boolean) {
        this.setState({
            editFilename: editFilename,
            editedFilename: this.state.shownImage.filename
        });
    }

    saveNewFilename() {
        this.props.actions
            .updateFilename(this.props.orderId, this.state.shownImage.id, this.state.editedFilename)
            .catch((error: any) => handleError(error));
    }

    onFilenameChange(e: any) {
        this.setState({ editedFilename: e.target.value });
    }

    getHeader() {
        if (this.state.editFilename) {
            return (
                <Form inline>
                    <ControlLabel>
                        {Translate('image-processing/modal/title/image-showcase')}
                    </ControlLabel>{' '}
                    <FormControl
                        onChange={this.onFilenameChange}
                        className="filename-input"
                        type="text"
                        value={this.state.editedFilename ? this.state.editedFilename : ''}
                    />{' '}
                    <Button bsStyle="primary" onClick={this.saveNewFilename}>
                        {Translate('image-processing/modal/title/button-label/save')}
                    </Button>{' '}
                    <Button bsStyle="danger" onClick={() => this.setEditFilenameInputState(false)}>
                        {Translate('image-processing/modal/title/button-label/cancel')}
                    </Button>
                </Form>
            );
        } else {
            let currentIndex = this.props.idList.indexOf(this.state.imageId) + 1;
            let numberOfPhotos = this.props.idList.length;

            return (
                <span>
                    {Translate('image-processing/modal/title/image-showcase')}{' '}
                    {this.state.shownImage.filename}{' '}
                    {Features.hasFeature(Features.UpdateFilename, this.props.user) && (
                        <Button
                            onClick={() => this.setEditFilenameInputState(true)}
                            bsSize="xsmall"
                        >
                            <i className="material-icons no-label">mode_edit</i>
                        </Button>
                    )}
                    <span className="image-count-display">
                        {'(' + currentIndex + ' / ' + numberOfPhotos + ')'}
                    </span>
                    {this.state.shownImage.category.value === 2 && (
                        <span className="caption category">
                            <span className="label label-warning pull-right image-flex-extra-display">
                                {this.props.isFlex
                                    ? Translate('image-processing/page/list/thumbnail/caption/flex')
                                    : Translate(
                                          'image-processing/page/list/thumbnail/caption/extra'
                                      )}
                            </span>
                        </span>
                    )}
                </span>
            );
        }
    }

    shouldShowCommentsSection() {
        return (
            Features.hasFeature(Features.ViewCommentsForAll, this.props.user) ||
            Features.hasFeature(Features.ViewCommentsForImageEditor, this.props.user) ||
            Features.hasFeature(Features.ViewCommentsForPhotographer, this.props.user)
        );
    }

    toggleShowDeleteConfirmationModal(show: boolean) {
        this.setState({ showDeleteConfirmationModal: show });
    }

    deleteEditedPhoto() {
        let hasParentId = this.state.shownImage.parentId;
        this.props.actions
            .deleteEditedPhoto(this.props.orderId, this.state.shownImage.id)
            .then(() => {
                notify.success(
                    Translate('image-processing/modal/delete-edited-photo/delete/message')
                );

                if (!hasParentId) {
                    this.props.toggleModal();
                }
            });
    }

    getStatusIcon(image: IImage, index: number) {
        let needsEditingType =
            this.state.images.length - 1 === index
                ? 'needs-editing'
                : 'returned-from-needs-editing';
        let commentType =
            this.state.images.length - 1 === index
                ? 'order-status/has-new-comments'
                : 'image-processing/page/list/thumbnail/icons/has-old-comments';

        return (
            <span>
                {image.hasComments && (
                    <i
                        title={Translate(commentType)}
                        className={'image-modal-status-icon material-icons'}
                    >
                        comment
                    </i>
                )}
                {image.needsEditing && (
                    <i
                        title={Translate('order-status/' + needsEditingType)}
                        className={'image-modal-status-icon material-icons'}
                    >
                        feedback
                    </i>
                )}
            </span>
        );
    }

    downloadExposures = (photoIds: number[]) => {
        actions
            .downloadMultipleExposures(this.props.orderId, photoIds)
            .catch((error: any) => handleError(error));
    };

    getReturnImageText() {
        if (this.state.needsEditing) {
            return Translate('image-processing/modal/input-label/returned');
        }

        return !this.state.comment.text
            ? Translate('image-processing/modal/input-label/needs-editing')
            : Translate('image-processing/modal/input-label/save-comment-needs-editing');
    }

    handleClickFavorite = (imageId: number, isFavorited: boolean) => {
        const { actions, orderId } = this.props;

        let newFavoritedStatus: boolean;

        if (!isFavorited) {
            actions.saveImageAsFavorite(orderId, imageId);
            newFavoritedStatus = true;
        } else {
            actions.resetImageAsFavorite(orderId, imageId);
            newFavoritedStatus = false;
        }

        const currentShownImage = Object.assign({}, this.state.shownImage);
        currentShownImage.isFavorited = newFavoritedStatus;
        this.setState({ shownImage: currentShownImage });
    };

    updatePreloadingImages = (prevState) => {
        let { user, photoStatus } = this.props;

        let isCustomer =
            user.details.role === UserRole.BrokerAgent ||
            UserRole.BrokerAgentAssistant ||
            UserRole.BrokerAgentAdmin;

        let isCustomerApprovedOrder = photoStatus >= PhotoStatus.CustomerApproved;

        /**
         * If the customer has not approved the order we display images
         * with watermark, so we do not want to expose the images without
         * watermark until the customer has approved an order.
         */
        if (isCustomer && !isCustomerApprovedOrder) {
            return;
        }

        if (prevState.shownImage.id !== this.state.shownImage.id) {
            const { apiUrl } = window.appConfig;
            const { idList } = this.props;
            let currentIdx = idList.indexOf(this.state.imageId);

            const images =
                this.props.imageType === ImageType.EDITED
                    ? this.props.editedImages
                    : this.props.uneditedImages;

            if (images.length > 0) {
                let nextImageIdx = currentIdx + 1;
                let prevImageIdx = currentIdx - 1;

                let nextImage,
                    prevImage = null;

                if (nextImageIdx < idList.length) {
                    nextImage = images[nextImageIdx];

                    nextImage = `${apiUrl}/file/${nextImage.previewReference}`;
                }

                if (prevImageIdx >= 0) {
                    prevImage = images[prevImageIdx];

                    prevImage = `${apiUrl}/file/${prevImage.previewReference}`;
                }

                this.setState({ nextImage, prevImage });
            }
        }
    };

    getImageDetails(isDng: boolean): string {
        const { width, height, fileSize, dpi } = this.state.shownImage;

        const sizeInMb = fileSize ? `${(fileSize / Math.pow(1024, 2)).toFixed(2)} MB` : 'N/A';

        if (isDng) {
            return sizeInMb;
        }

        const sizeInPx = width && height ? `${width} x ${height} px` : 'N/A';
        const dpiValue = dpi ? `${dpi} DPI` : 'N/A';

        return `${sizeInPx}, ${sizeInMb}, ${dpiValue}`;
    }

    componentDidUpdate(prevProps, prevState) {
        this.updatePreloadingImages(prevState);
    }

    render() {
        const canDeletePhotos =
            this.props.photoStatus >= PhotoStatus.EditorApproved
                ? Features.hasFeature(Features.DeleteImagesAcceptedOrder, this.props.user)
                : true;
        const originalImages = this.state.images.filter((x: IImage) => x.parentId === null);
        const originalImagesCount = originalImages.length;

        const isDng = this.state.shownImage.filename.toLowerCase().endsWith('.dng');

        const { apiUrl } = window.appConfig;

        return (
            <div>
                {this.state.shownImage.reference !== '' && this.state.shownImage.id !== 0 && (
                    <Modal
                        id="order-image-processing"
                        bsStyle="modal-fs"
                        style={{ zIndex: 1100 }}
                        show={this.props.showModal}
                        onHide={this.props.toggleModal}
                        enforceFocus={false}
                    >
                        <Modal.Header closeButton className="image-processing-modal-header">
                            <Modal.Title className="pull-left">{this.getHeader()}</Modal.Title>
                            {!this.props.hasEditCustomerImages &&
                                !this.props.user.details.isCustomer && (
                                    <ImageProcessingCategorySection
                                        categories={this.props.categories}
                                        categoryNameTranslation={
                                            this.state.shownImage.category.displayName
                                        }
                                        allowChange={this.props.allowChangeCategories}
                                        onCategorySave={this.onCategorySave}
                                    />
                                )}
                        </Modal.Header>
                        <Modal.Body>
                            <SwipeListener
                                onSwipeLeft={() => this.stepInGallery(Direction.Left)}
                                onSwipeRight={() => this.stepInGallery(Direction.Right)}
                            >
                                <div>
                                    {this.state.nextImage ? (
                                        <PreloadImageContainer imageSrc={this.state.nextImage} />
                                    ) : null}
                                    {this.state.prevImage ? (
                                        <PreloadImageContainer imageSrc={this.state.prevImage} />
                                    ) : null}
                                </div>
                                {this.props.imageType === ImageType.EDITED && (
                                    <div className="imageprocessing-dropzone-wrapper">
                                        <Row>
                                            <Col md={7}>
                                                <Row>
                                                    <Col md={10}>
                                                        {this.props.imageType ===
                                                            ImageType.EDITED &&
                                                            !this.props.user.details.isCustomer && (
                                                            <ButtonGroup>
                                                                {this.state.images &&
                                                                 this.state.images.map(
                                                                    (
                                                                        image: IImage,
                                                                        index: number
                                                                    ) => {
                                                                        if (
                                                                            (!image.parentId &&
                                                                                !Features.hasFeature(
                                                                                    Features.ViewUneditedImages,
                                                                                    this.props
                                                                                        .user
                                                                                )) ||
                                                                            (originalImagesCount >
                                                                                1 &&
                                                                                index > 0 &&
                                                                                !image.parentId)
                                                                        ) {
                                                                            return;
                                                                        }

                                                                        return (
                                                                            <Button
                                                                                onClick={() => {
                                                                                    this.showImage(
                                                                                        image,
                                                                                        index
                                                                                    );
                                                                                }}
                                                                                key={image.id}
                                                                                bsStyle={
                                                                                    this.state
                                                                                        .shownImage
                                                                                        .id ===
                                                                                        image.id ||
                                                                                        (originalImages.find((x) =>
                                                                                            x.id === image.id
                                                                                        ) &&
                                                                                            originalImages.find((x) =>
                                                                                                x.id ===
                                                                                                this.state
                                                                                                    .shownImage
                                                                                                    .id
                                                                                            ))
                                                                                        ? 'primary'
                                                                                        : 'default'
                                                                                }
                                                                            >
                                                                                {!image.parentId
                                                                                    ? Translate(
                                                                                        'image-processing/modal/button-label/original'
                                                                                    )
                                                                                    : moment(image.time).format(
                                                                                        'L LT'
                                                                                    )}{' '}
                                                                                {this.getStatusIcon(
                                                                                    image,
                                                                                    index
                                                                                )}
                                                                            </Button>
                                                                        );
                                                                    }
                                                                )}
                                                            </ButtonGroup>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <ImageProcessingDropzone
                                            needsEditing={this.state.needsEditing}
                                            id={this.state.imageId}
                                            orderId={this.props.orderId}
                                            isImageEdited={
                                                this.props.imageType === ImageType.EDITED
                                            }
                                            isImageFavorite={Boolean(
                                                this.state.shownImage.isFavorited
                                            )}
                                            onClickFavorite={this.handleClickFavorite}
                                            lowResImageSrc={this.state.shownImage.reference}
                                            highResImageSrc={
                                                this.state.shownImage.highResImageReference
                                            }
                                            getLatestChildImage={this.getLatestChildImage}
                                            canImageZoom={Features.hasFeature(
                                                Features.ViewHighResolutionImageZoom,
                                                this.props.user
                                            )}
                                            photographerIsEditor={this.props.photographerIsEditor}
                                            loaded={this.state.isImageLoaded}
                                            onLoad={() => this.setState({ isImageLoaded: true })}
                                        />
                                        {originalImagesCount > 1 &&
                                            this.state.shownImage.parentId === null && (
                                                <Row className="imageprocessing-multiple-originals-row">
                                                    {originalImages.map(
                                                        (image: IImage, index: number) => (
                                                            <div
                                                                key={`original-image-${index}`}
                                                                className={`original-thumbnail-border ${
                                                                    this.state.shownImage.id ===
                                                                    image.id
                                                                        ? 'selected'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <div className="original-thumbnail-container">
                                                                    <img
                                                                        src={`${apiUrl}/file/${image.thumbnailReference}`}
                                                                        className="original-image-thumbnail"
                                                                        onClick={() =>
                                                                            this.showImage(
                                                                                image,
                                                                                index
                                                                            )
                                                                        }
                                                                        draggable={false}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                    <Button
                                                        bsStyle="info"
                                                        onClick={() =>
                                                            this.downloadExposures(
                                                                originalImages.map(
                                                                    (image: IImage) => image.id
                                                                )
                                                            )
                                                        }
                                                    >
                                                        <i className="material-icons md-18">
                                                            file_download
                                                        </i>
                                                        {Translate(
                                                            'imageprocessing/modal/download-exposures/button'
                                                        )}
                                                    </Button>
                                                </Row>
                                            )}
                                    </div>
                                )}
                                {this.props.imageType === ImageType.UNEDITED && (
                                    <ImageZoom
                                        lowResImageSrc={`${apiUrl}/file/${this.state.shownImage.reference}`}
                                        highResImageSrc={`${apiUrl}/file/${this.state.shownImage.highResImageReference}`}
                                        isImageEdited={false}
                                        canZoom={
                                            Features.hasFeature(
                                                Features.ViewHighResolutionImageZoom,
                                                this.props.user
                                            ) && !isDng
                                        }
                                        canFavourite={Features.hasFeature(
                                            Features.FavoriteImages,
                                            this.props.user
                                        )}
                                        loaded={this.state.isImageLoaded}
                                        onLoad={() => this.setState({ isImageLoaded: true })}
                                    />
                                )}
                                {this.shouldShowCommentsSection() && (
                                    <Panel
                                        className="image-processing-modal-comment-panel"
                                        collapsible={false}
                                        expanded={true}
                                    >
                                        <ImageProcessingCommentsSection
                                            latestImageId={
                                                this.state.images[this.state.images.length - 1].id
                                            }
                                            shownImageId={this.state.shownImage.id}
                                            filter={this.state.filter}
                                            comment={this.state.comment}
                                            comments={this.state.shownImage.comments}
                                            role={this.state.role}
                                            onChange={this.formInputChangeHandler.onChange}
                                            errors={this.state.comment.errors}
                                            user={this.props.user}
                                            hideImageEditor={
                                                this.props.photographerIsEditor === true
                                            }
                                            recipientIsObligatory={this.state.comment.text}
                                        />
                                        <ButtonToolbar>
                                            {this.state.images[this.state.images.length - 1].id ===
                                                this.state.shownImage.id && (
                                                <Button
                                                    onClick={this.saveComment}
                                                    disabled={
                                                        !this.enableSaveComment() ||
                                                        !this.state.comment.text
                                                    }
                                                    bsStyle="primary"
                                                >
                                                    <i className="material-icons">comment</i>
                                                    {Translate(
                                                        'image-processing/modal/footer/button-label/save-comment'
                                                    )}
                                                </Button>
                                            )}

                                            {this.props.imageType === ImageType.EDITED &&
                                                Features.hasFeature(
                                                    Features.SetNeedsEditing,
                                                    this.props.user
                                                ) &&
                                                this.state.images[this.state.images.length - 1]
                                                    .id === this.state.shownImage.id && (
                                                    <Button
                                                        bsStyle={
                                                            this.state.needsEditing
                                                                ? 'default'
                                                                : 'warning'
                                                        }
                                                        checked={this.state.needsEditing === true}
                                                        onClick={this.setNeedsEditingState}
                                                        disabled={
                                                            this.state.comment.text &&
                                                            !this.enableSaveComment()
                                                        }
                                                        active={this.state.needsEditing}
                                                    >
                                                        <i className="material-icons">undo</i>
                                                        {this.getReturnImageText()}
                                                    </Button>
                                                )}
                                        </ButtonToolbar>
                                        {(this.props.imageType === ImageType.EDITED &&
                                            this.props.user.details.role === UserRole.Admin) ||
                                        (this.props.imageType === ImageType.EDITED &&
                                            this.props.user.details.role === UserRole.Support) ? (
                                            <div className="image-processing-modal-room-tag">
                                                <ImageProcessingRoomTagging
                                                    user={this.props.user}
                                                    availableRoomCategories={
                                                        this.props.availableRoomTags
                                                    }
                                                    existingRoomCategories={
                                                        this.props.existingRoomTags
                                                    }
                                                    labels={{
                                                        roomTaggingInputLabel: Translate(
                                                            'image-processing/page/selectRoomTag/select-input-label'
                                                        ),
                                                        roomTaggingAddTag: Translate(
                                                            'image-processing/page/selectRoomTag/add-tag'
                                                        ),
                                                        errors: {
                                                            addRoomTag: Translate(
                                                                'image-processing/page/selectRoomTag/error/addTag'
                                                            ),
                                                            deleteRoomTag: Translate(
                                                                'image-processing/page/selectRoomTag/error/deleteTag'
                                                            )
                                                        },
                                                        roomTag: (displayName: string): string =>
                                                            Translate(displayName)
                                                    }}
                                                    orderId={this.props.orderId}
                                                    imageId={
                                                        this.state.shownImage
                                                            ? this.state.shownImage.id
                                                            : null
                                                    }
                                                />
                                            </div>
                                        ) : null}
                                    </Panel>
                                )}
                            </SwipeListener>
                        </Modal.Body>
                        <Modal.Footer>
                            {!this.props.user.details.isCustomer && (
                                <span className="pull-left">{this.getImageDetails(isDng)}</span>
                            )}
                            {(Features.hasFeature(Features.DownloadNormalImage, this.props.user) ||
                                this.props.photoStatus === PhotoStatus.CustomerApproved ||
                                this.props.photoStatus === PhotoStatus.Delivered ||
                                this.props.photoStatus === PhotoStatus.DeliveryError ||
                                this.props.photoStatus === PhotoStatus.ScheduledForCustomerApproval ||
                                this.props.photoStatus === PhotoStatus.DeliveryStarted) &&
                                this.state.shownImage.normalImageReference && (
                                    <a
                                        href={`${apiUrl}/file/${this.state.shownImage.normalImageReference}`}
                                        target="_blank"
                                        className="btn btn-info normal-image-icon-btn"
                                    >
                                        <img
                                            className="normal-image-icon"
                                            src={normalIcon}
                                            title={Translate(
                                                'image-processing/page/list/thumbnail/icons/has-uploaded-normal'
                                            )}
                                        />
                                    </a>
                                )}
                            {Features.hasFeature(
                                Features.DownloadHighResolutionImage,
                                this.props.user
                            ) &&
                                this.state.shownImage.highResImageReference && (
                                    <Button
                                        className="image-processing-float-button btn-info"
                                        onClick={this.downloadImage}
                                    >
                                        <i className="material-icons md-18 no-label">
                                            file_download
                                        </i>
                                    </Button>
                                )}
                            {(Features.hasFeature(Features.DeleteEditedImage, this.props.user) ||
                                (this.props.photographerIsEditor &&
                                    Features.hasFeature(
                                        Features.HandleEditedImagesWhenPhotographerIsEditor,
                                        this.props.user
                                    ))) &&
                                canDeletePhotos && (
                                    <span>
                                        {this.state.shownImage.canDelete && (
                                            <Button
                                                bsStyle="danger"
                                                disabled={
                                                    this.state.shownImage.hasDeliveryConnection
                                                }
                                                title={
                                                    this.state.shownImage.hasDeliveryConnection
                                                        ? Translate(
                                                              'image-processing/modal/delete-edited-photo/already-delivered'
                                                          )
                                                        : ''
                                                }
                                                onClick={() =>
                                                    this.toggleShowDeleteConfirmationModal(true)
                                                }
                                            >
                                                {Translate(
                                                    'image-processing/modal/delete-edited-photo/delete-button'
                                                )}
                                            </Button>
                                        )}
                                        {!this.state.shownImage.canDelete && (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="tooltip">
                                                        <p>
                                                            <strong>
                                                                {Translate(
                                                                    'image-processing/modal/delete-edited-photo/delete-button/disabled/info/title'
                                                                )}
                                                            </strong>
                                                            <br />
                                                            {this.state.shownImage.index ===
                                                            this.state.images.length - 1
                                                                ? Translate(
                                                                      'image-processing/modal/delete-edited-photo/delete-button/disabled/info/content/not-uploaded-by-you'
                                                                  )
                                                                : Translate(
                                                                      'image-processing/modal/delete-edited-photo/delete-button/disabled/info/content/not-latest-photo'
                                                                  )}
                                                        </p>
                                                    </Tooltip>
                                                }
                                            >
                                                <span>
                                                    <Button bsStyle="danger" className="disabled">
                                                        {Translate(
                                                            'image-processing/modal/delete-edited-photo/delete-button'
                                                        )}
                                                    </Button>
                                                </span>
                                            </OverlayTrigger>
                                        )}
                                    </span>
                                )}
                            <Button onClick={this.props.toggleModal}>
                                {Translate('image-processing/modal/footer/button-label/close')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {this.state.showDeleteConfirmationModal && (
                    <ConfirmationModal
                        title={Translate(
                            'image-processing/modal/delete-edited-photo/confirmation-modal/title'
                        )}
                        text={Translate(
                            'image-processing/modal/delete-edited-photo/confirmation-modal/text'
                        )}
                        doButtonLabel={Translate(
                            'image-processing/modal/delete-edited-photo/confirmation-modal/do-button'
                        )}
                        cancelButtonLabel={Translate(
                            'image-processing/modal/delete-edited-photo/confirmation-modal/cancel-button'
                        )}
                        doButtonStyle="danger"
                        do={this.deleteEditedPhoto}
                        closeModal={() => this.toggleShowDeleteConfirmationModal(false)}
                    />
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getImage: (orderId: number, id: number) => dispatch(actions.getImage(orderId, id)),
            getLatestImage: (orderId: number, id: number) =>
                dispatch(actions.getLatestImage(orderId, id)),
            saveComment: (orderId: number, id: number, comment: string, recipients: number) =>
                dispatch(actions.saveComment(orderId, id, comment, recipients)),
            saveNeedsEditing: (orderId: number, id: number, needsEditing: boolean) =>
                dispatch(actions.saveNeedsEditing(orderId, id, needsEditing)),
            getCategories: (orderId: number) => dispatch(actions.getCategories(orderId)),

            updateCategory: (orderId: number, id: number, category: number): Promise<void> =>
                dispatch(actions.updateCategory(orderId, id, category)),

            updateFilename: (orderId: number, id: number, filename: string) =>
                dispatch(actions.updateFilename(orderId, id, filename)),
            deleteEditedPhoto: (photoOrderId: number, photoId: number) =>
                dispatch(actions.deleteEditedPhoto(photoOrderId, photoId)),
            getPhotoStatus: (orderId: number) => dispatch(actions.getPhotoStatus(orderId)),
            saveImageAsFavorite: (orderId: number, imageId: number) =>
                dispatch(actions.saveImageAsFavorite(orderId, imageId)),
            resetImageAsFavorite: (orderId: number, imageId: number) =>
                dispatch(actions.resetImageAsFavorite(orderId, imageId))
        }
    };
}

function mapStateToProps(state: any) {
    let editedImages = selectEditedImages(state);
    let uneditedImages = selectUneditedImages(state);

    let editedThumbnails = editedImages.list[0] ? editedImages.list[0].thumbnails : [];
    let uneditedThumbnails = uneditedImages.list[0] ? uneditedImages.list[0].thumbnails : [];

    return {
        images: state.imageProcessing.modal.images,
        orderRows: state.imageProcessing.edited.list,
        user: state.user,
        categories: state.imageProcessing.modal.categories,
        allowChangeCategories: state.imageProcessing.modal.allowChangeCategories,
        availableRoomTags: state.imageProcessing.modal.availableRoomTags,
        existingRoomTags: state.imageProcessing.modal.existingRoomTags,
        hasEditCustomerImages: state.imageProcessing.photoStatus.hasEditCustomerImages,
        photographerIsEditor: state.imageProcessing.photoStatus.photographerIsEditor,
        hasFlex: state.imageProcessing.photoStatus.hasFlex,
        editedImages: editedThumbnails,
        uneditedImages: uneditedThumbnails
    };
}

function ImageProcessingModalWithFeatureToggle(props) {
    return <ImageProcessingModal {...props} />;
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageProcessingModalWithFeatureToggle);
